export default "__VITE_ASSET__DkVXMqes__"